import { render, staticRenderFns } from "./ProductysManager.vue?vue&type=template&id=6117a675&"
import script from "./ProductysManager.vue?vue&type=script&lang=js&"
export * from "./ProductysManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports